module.exports = __webpack_public_path__ + "static/media/Sharp-LP285A6NW11-Tech-Drawing.3b50c3f3.png";